import { isGodMode } from '../godMode/session';

/**
 * Statut bloquant d'une entreprise cliente, lu sur l'identité renvoyée par
 * `GET /auth/me` (`companyStatus`). Le statut n'a pas de défaut : absent ou
 * inconnu = actif.
 *
 * En God Mode l'accès n'est JAMAIS bloqué (SPEC §4.1) : l'équipe intervient
 * précisément sur les comptes suspendus ou clôturés.
 */
export const ACCOUNT_SUSPENDED = 'ACCOUNT_SUSPENDED';
export const ACCOUNT_CLOSED = 'ACCOUNT_CLOSED';
export const BLOCKED_CODES = [ACCOUNT_SUSPENDED, ACCOUNT_CLOSED];

export function blockedStatusOf(user) {
  if (isGodMode()) return null;
  const statut = user && user.companyStatus;
  return statut === 'suspended' || statut === 'closed' ? statut : null;
}
